<template>
    <div class="container mt-4" v-if="$isAllowed('read')">

        <div class="row">
            <div class="col-12">
                <el-tabs v-model="activeName" @tab-click="handleClick" type="border-card">
                    <!-- <el-tab-pane label="Config" name="config">
                           <div class="row">
                                <div class="col-12">
                                    <cph-widget>
                                        <h2 slot="header">Receipt data</h2>
                                        <company-data-form slot="body"></company-data-form>
                                    </cph-widget>
                                </div>
                            </div>
                            <div class="row" v-if="$isAllowed('exporting')">
                                <div class="col-12">
                                    <cph-widget>
                                        <h2 slot="header">Config</h2>
                                        <cph-config slot="body"></cph-config>
                                    </cph-widget>
                                </div>
                            </div>
                    </el-tab-pane> -->
                    <!-- <el-tab-pane label="Terms" name="terms">
                        <Editor />
                    </el-tab-pane> -->
                    <el-tab-pane label="Update tasks" name="updatetasks">
                        <UpdateTasks />
                    </el-tab-pane>
                    <!-- <el-tab-pane label="Loadbalancing" name="loadbalancing">
                        <Guard :showFor="['admin']">
                            <Loadbalancer />
                        </Guard>
                    </el-tab-pane> -->
                </el-tabs>
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import {ConfigPerimeter} from '../../../router/perimeters/configPerimeter';
import CphWidget from '../../../components/Shared/CphWidget.vue';
import CompanyDataForm from '../../../components/Panel/Account/CompanyDataForm/CompanyDataForm.vue';
import CphConfig from '../../../components/Panel/Account/Config/CphConfig.vue';
import Editor from '../../../components/Panel/Account/Editor/Editor.vue'; 
import UpdateTasks from '../../../components/Panel/Account/UpdateTasks/UpdateTasks.vue'; 
import Loadbalancer from '../../../components/Panel/Account/Loadbalancer/Loadbalancer.vue'; 
export default {
    name: 'Account',
    components: {
        CphWidget,
        CompanyDataForm,
        CphConfig,
        Editor,
        UpdateTasks,
        Loadbalancer
    },
    perimeters: [
        ConfigPerimeter
    ],
    data(){
        return {
            activeName: 'updatetasks'
        }
    },
    methods: {
      handleClick(tab, event) {
      }
    },
    created(){
        if(this.$route.query.tab)
            this.activeName = this.$route.query.tab
    }
};
</script>
